module.exports = __webpack_public_path__ + "static/media/complexPic11.4a0c71fa.png";